import React from 'react'
import Tooltip from 'antd/lib/tooltip'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import styles from './styles.module.scss'

interface IFormLabel {
  label: string
  tooltip?: string
}

const FormLabel: React.FC<IFormLabel> = ({ label, tooltip }) => {
  return (
    <span className='rankmiSignature-formLabel'>
      <label className={`${styles.label} ant-form-item-label`}>{label}</label>
      {tooltip && (
        <Tooltip title={tooltip} className={styles.tooltip}>
          <FontAwesomeIcon icon={faExclamationCircle as IconProp} size='xs' />
        </Tooltip>
      )}
    </span>
  )
}

export default FormLabel
